// extracted by mini-css-extract-plugin
export default {"heading":"BillbackDetailsHeader_heading__ABmn3","grid":"BillbackDetailsHeader_grid__x8tNP"};